// extracted by mini-css-extract-plugin
module.exports = {"PageTop":"Page_PageTop__8U9Pk","Title":"Page_Title__364Bk"};